module.exports = __webpack_public_path__ + "fonts/Avenir-BookOblique.2562f56.woff2";